module.exports = __webpack_public_path__ + "static/media/icon-payment.a69105c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-payment.svg
// module id = 2893
// module chunks = 0